import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Partner = (props: IIcon) => {
  const { className = '', ...rest } = props;
  return (
    <svg
      {...rest}
      className={classNames(className)}
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={60}
      viewBox="0 0 61 60"
      fill="none"
    >
      <g clipPath="url(#clip0_419_6107)">
        <path
          d="M60.5 30C60.5 13.4315 47.0685 0 30.5 0C13.9315 0 0.5 13.4315 0.5 30C0.5 46.5685 13.9315 60 30.5 60C47.0685 60 60.5 46.5685 60.5 30Z"
          fill="#EBFBFF"
        />
        <path
          d="M40.4994 30.0002V30.0502C40.4989 31.2353 40.137 32.3922 39.4619 33.3663C38.7868 34.3404 37.8307 35.0854 36.7211 35.502C35.6116 35.9185 34.4014 35.9868 33.252 35.6976C32.1027 35.4084 31.0688 34.7755 30.2885 33.8835L26.4552 29.5027C25.754 28.7002 24.8172 28.14 23.7785 27.902C22.7398 27.6641 21.6524 27.7605 20.6719 28.1776"
          stroke="#4DDFFD"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.5708 22.9287C38.9694 24.3272 39.9219 26.109 40.3078 28.0489C40.6937 29.9887 40.4957 31.9994 39.7389 33.8267C38.982 35.654 37.7003 37.2158 36.0558 38.3147C34.4113 39.4135 32.4779 40 30.5 40C28.5222 40 26.5887 39.4135 24.9442 38.3147C23.2997 37.2158 22.018 35.654 21.2611 33.8267C20.5043 31.9994 20.3063 29.9887 20.6922 28.0489C21.0781 26.109 22.0306 24.3272 23.4292 22.9287C25.3045 21.0535 27.848 20 30.5 20C33.1521 20 35.6955 21.0535 37.5708 22.9287Z"
          stroke="#4DDFFD"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.43 28.8534L37.4992 27.3876C36.216 26.7459 34.7634 26.5244 33.3472 26.7544C31.9311 26.9845 30.6233 27.6544 29.6092 28.6693L26.6092 31.6693C26.1003 32.1778 25.4684 32.546 24.7751 32.7379C24.0817 32.9298 23.3504 32.9389 22.6525 32.7643C22.0368 32.6096 21.4905 32.2535 21.1005 31.7527C20.7105 31.2518 20.4991 30.6349 20.5 30.0001"
          stroke="#4DDFFD"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.0092 33.0833L37.1375 31.6483C36.1754 31.1669 35.0861 31.0005 34.0241 31.1728C32.9621 31.3451 31.9813 31.8474 31.2208 32.6083L28.8958 34.9333C28.1014 35.7028 27.0548 36.1578 25.9502 36.2139C24.8457 36.27 23.7583 35.9234 22.89 35.2383C22.1419 34.6103 21.5403 33.8262 21.1274 32.941C20.7146 32.0558 20.5004 31.0909 20.5 30.1142V30"
          stroke="#4DDFFD"
          strokeWidth="2.22222"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_419_6107">
          <rect width={60} height={60} fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Partner;
